import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMessages(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/messages/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchMessage(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/messages/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editMessage(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/messages", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteMessage(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/messages", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
